module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Book-56e46dd26062a08cfc7c25f820f8fef8.ttf";